import { EnumToArrayPipe } from './../../../pipes/enum-to-array.pipe';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

@NgModule({
  declarations: [EnumToArrayPipe],
  imports: [CommonModule],
  exports: [EnumToArrayPipe],
})
export class EnumToArrayModule {}
